import __request__ from "routing/request";
export function show(requestOptions) {
  return __request__("GET", "/system/journal", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
